import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  Phases_getInstance3j81i0dosd478 as Phases_getInstance_0,
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
} from '../statement/HttpResponsePipeline.mjs';
import {
  platformResponseDefaultTransformers258gm9ywvn5cc as platformResponseDefaultTransformers,
  platformRequestDefaultTransformv8a3p2llr8mo as platformRequestDefaultTransform,
} from './DefaultTransform.web.mjs';
import {
  Unit_instance28fytmsmm6r23 as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contentType2zzm38yxo3syt as contentType,
  contentLength2suzxu1lzutku as contentLength,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  canceldn4b3cdqcfny as cancel,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isByteArray4nnzfn1x4o3w as isByteArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Text_getInstance38vnirw8um9kn as Text_getInstance,
  Application_getInstanceueakgx5l255p as Application_getInstance,
  Companion_getInstance24sa2b20ejg3q as Companion_getInstance,
  MultiPart_getInstance2hpkqlzozpomu as MultiPart_getInstance,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toLongkk4waq8msp1k as toLong,
  toInt2q8uldh7sc951 as toInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  copyTo3z8um8xkg7g1 as copyTo,
  toByteArray2f7h1d87fvkuc as toByteArray,
  readRemaininghtnrfi4c8vp0 as readRemaining,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  cancel2ztysw4v4hav6 as cancel_0,
  cancel36mj9lv3a0whl as cancel_1,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from '../../../../../ktor-ktor-http-cio/io/ktor/http/cio/CIOMultipartDataBase.mjs';
import { MultiPartData57syw40llxls as MultiPartData } from '../../../../../ktor-ktor-http/io/ktor/http/content/Multipart.mjs';
import { HttpStatusCode3o1wkms10pg4k as HttpStatusCode } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  Key_instance17dpgmdbeabno as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  writer1eia5its2a1fh as writer,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
  WriterScope3b0bo1enaee6b as WriterScope,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from '../call/utils.mjs';
import { PrimitiveClasses_getInstance6p7zmos9nw3c as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { Source1shr0ps16u4p4 as Source } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Source.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER;
}
var LOGGER;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().d5m_1;
  _this__u8e3s4.p5f_1.f4r(tmp, defaultTransformers$slambda_0());
  var tmp_0 = Phases_getInstance_0().i5h_1;
  _this__u8e3s4.q5f_1.f4r(tmp_0, defaultTransformers$slambda_2(_this__u8e3s4));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
function *_generator_invoke__zhh2q8($this, $this$intercept, body, $completion) {
  if ($this$intercept.b4r_1.i5g_1.l2o('Accept') == null) {
    $this$intercept.b4r_1.i5g_1.h4o('Accept', '*/*');
  }
  var contentType_0 = contentType($this$intercept.b4r_1);
  var tmp;
  if (typeof body === 'string') {
    tmp = new (TextContent())(body, contentType_0 == null ? Text_getInstance().o4u_1 : contentType_0);
  } else {
    if (isByteArray(body)) {
      tmp = new (defaultTransformers$2$content$1())(contentType_0, body);
    } else {
      if (isInterface(body, ByteReadChannel())) {
        tmp = new (defaultTransformers$2$content$2())($this$intercept, contentType_0, body);
      } else {
        if (body instanceof OutgoingContent()) {
          tmp = body;
        } else {
          tmp = platformRequestDefaultTransform(contentType_0, $this$intercept.b4r_1, body);
        }
      }
    }
  }
  var content = tmp;
  if (!((content == null ? null : content.g47()) == null)) {
    $this$intercept.b4r_1.i5g_1.l4o('Content-Type');
    get_LOGGER().f4s('Transformed with default transformers request body for ' + $this$intercept.b4r_1.g5g_1.toString() + ' from ' + toString(getKClassFromExpression(body)));
    var tmp_0 = $this$intercept.d4q(content, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var defaultTransformers$2$content$1Class;
function defaultTransformers$2$content$1() {
  if (defaultTransformers$2$content$1Class === VOID) {
    class $ extends ByteArrayContent() {
      constructor($contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.o5o_1 = $body;
        super($box);
        var tmp = this;
        tmp.m5o_1 = $contentType == null ? Application_getInstance().l4t_1 : $contentType;
        this.n5o_1 = fromInt($body.length);
      }
      g47() {
        return this.m5o_1;
      }
      h47() {
        return this.n5o_1;
      }
      v55() {
        return this.o5o_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$2$content$1Class = $;
  }
  return defaultTransformers$2$content$1Class;
}
var defaultTransformers$2$content$2Class;
function defaultTransformers$2$content$2() {
  if (defaultTransformers$2$content$2Class === VOID) {
    class $ extends ReadChannelContent() {
      constructor($this_intercept, $contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.s5o_1 = $body;
        super($box);
        var tmp = this;
        var tmp0_safe_receiver = $this_intercept.b4r_1.i5g_1.l2o('Content-Length');
        tmp.q5o_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
        var tmp_0 = this;
        tmp_0.r5o_1 = $contentType == null ? Application_getInstance().l4t_1 : $contentType;
      }
      h47() {
        return this.q5o_1;
      }
      g47() {
        return this.r5o_1;
      }
      y55() {
        return this.s5o_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$2$content$2Class = $;
  }
  return defaultTransformers$2$content$2Class;
}
var defaultTransformers$slambdaClass;
function defaultTransformers$slambda() {
  if (defaultTransformers$slambdaClass === VOID) {
    class $ {
      m5g($this$intercept, body, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, body), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.m5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaultTransformers$slambdaClass = $;
  }
  return defaultTransformers$slambdaClass;
}
function defaultTransformers$slambda_0() {
  var i = new (defaultTransformers$slambda())();
  var l = ($this$intercept, body, $completion) => i.m5g($this$intercept, body, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$writer, $completion) {
  try {
    var tmp = copyTo($this.t5o_1, $this$writer.c4k_1, 9223372036854775807n, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var cause = $p;
      cancel_1($this.u5o_1, cause);
      throw cause;
    } else {
      if ($p instanceof Error) {
        var cause_0 = $p;
        cancel_0($this.u5o_1, 'Receive failed', cause_0);
        throw cause_0;
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$intercept, _destruct__k2r9zo, $completion) {
  var info = _destruct__k2r9zo.df();
  var body = _destruct__k2r9zo.ef();
  if (!isInterface(body, ByteReadChannel()))
    return Unit_instance;
  var response = $this$intercept.b4r_1.d5g();
  var tmp0_subject = info.t4r_1;
  var tmp;
  if (tmp0_subject.equals(getKClass(Unit()))) {
    cancel(body);
    var tmp_0 = $this$intercept.d4q(new (HttpResponseContainer())(info, Unit_instance), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().bg())) {
    var tmp_1 = readRemaining(body, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = $this$intercept.d4q(new (HttpResponseContainer())(info, toInt(readText(tmp_1))), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp = tmp_2;
  } else if (tmp0_subject.equals(getKClass(Source())) || tmp0_subject.equals(getKClass(Source()))) {
    var tmp_3 = readRemaining(body, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = $this$intercept.d4q(new (HttpResponseContainer())(info, tmp_3), $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().kg())) {
    var tmp_5 = toByteArray(body, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var bytes = tmp_5;
    checkContentLength(contentLength($this$intercept.b4r_1.d5g()), fromInt(bytes.length), $this$intercept.b4r_1.z5h().h5i());
    var tmp_6 = $this$intercept.d4q(new (HttpResponseContainer())(info, bytes), $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp = tmp_6;
  } else if (tmp0_subject.equals(getKClass(ByteReadChannel()))) {
    var responseJobHolder = Job(response.ew().hd(Key_instance));
    // Inline function 'kotlin.also' call
    var this_0 = writer($this$intercept, $this.v5o_1.o5f_1, VOID, defaultTransformers$slambda$slambda_0(body, response));
    invokeOnCompletion(this_0, (it) => {
      responseJobHolder.w12();
      return Unit_instance;
    });
    var channel = this_0.a4k_1;
    var tmp_7 = $this$intercept.d4q(new (HttpResponseContainer())(info, channel), $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    tmp = tmp_7;
  } else if (tmp0_subject.equals(getKClass(HttpStatusCode()))) {
    cancel(body);
    var tmp_8 = $this$intercept.d4q(new (HttpResponseContainer())(info, response.p5i()), $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    tmp = tmp_8;
  } else if (tmp0_subject.equals(getKClass(MultiPartData()))) {
    var tmp0 = $this$intercept.b4r_1.d5g().a50().l2o('Content-Type');
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'No content type provided for multipart';
        throw IllegalStateException().o(toString(message));
      } else {
        tmp$ret$3 = tmp0;
        break $l$block;
      }
    }
    var rawContentType = tmp$ret$3;
    var contentType = Companion_getInstance().ot(rawContentType);
    // Inline function 'kotlin.check' call
    if (!contentType.b4v(MultiPart_getInstance().i4u_1)) {
      var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
      throw IllegalStateException().o(toString(message_0));
    }
    var tmp1_safe_receiver = $this$intercept.b4r_1.d5g().a50().l2o('Content-Length');
    var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
    var body_0 = new (CIOMultipartDataBase())($this$intercept.ew(), body, rawContentType, contentLength_0);
    var parsedResponse = new (HttpResponseContainer())(info, body_0);
    var tmp_9 = $this$intercept.d4q(parsedResponse, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    tmp = tmp_9;
  } else {
    tmp = null;
  }
  var result = tmp;
  if (!(result == null)) {
    get_LOGGER().f4s('Transformed with default transformers response body ' + ('for ' + $this$intercept.b4r_1.z5h().i5i().toString() + ' to ' + toString(info.t4r_1)));
  }
  return Unit_instance;
}
var defaultTransformers$slambda$slambdaClass;
function defaultTransformers$slambda$slambda() {
  if (defaultTransformers$slambda$slambdaClass === VOID) {
    class $ {
      constructor($body, $response) {
        this.t5o_1 = $body;
        this.u5o_1 = $response;
      }
      o58($this$writer, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$writer), $completion);
      }
      ud(p1, $completion) {
        return this.o58(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    defaultTransformers$slambda$slambdaClass = $;
  }
  return defaultTransformers$slambda$slambdaClass;
}
function defaultTransformers$slambda$slambda_0($body, $response) {
  var i = new (defaultTransformers$slambda$slambda())($body, $response);
  var l = ($this$writer, $completion) => i.o58($this$writer, $completion);
  l.$arity = 1;
  return l;
}
var defaultTransformers$slambdaClass_0;
function defaultTransformers$slambda_1() {
  if (defaultTransformers$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_defaultTransformers) {
        this.v5o_1 = $this_defaultTransformers;
      }
      n5g($this$intercept, _destruct__k2r9zo, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$intercept, _destruct__k2r9zo), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.n5g(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaultTransformers$slambdaClass_0 = $;
  }
  return defaultTransformers$slambdaClass_0;
}
function defaultTransformers$slambda_2($this_defaultTransformers) {
  var i = new (defaultTransformers$slambda_1())($this_defaultTransformers);
  var l = ($this$intercept, _destruct__k2r9zo, $completion) => i.n5g($this$intercept, _destruct__k2r9zo, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
//region block: exports
export {
  defaultTransformers as defaultTransformers2r9wd7ftt31zw,
};
//endregion

//# sourceMappingURL=DefaultTransform.mjs.map
